import * as React from "react"
import { ChakraProvider } from "@chakra-ui/react"
import { system } from "./src/theme"
import Layout from "./src/components/Layout"
import { LeadFormProvider } from "./src/context/LeadFormContext"
import LeadFormModal from "./src/components/LeadFormModal"
import { OwnerLeadFormProvider } from "./src/context/OwnerLeadFormContext"
import { GetStartedProvider } from "./src/context/GetStartedContext"
import GetStartedChoiceModal from "./src/components/GetStartedChoiceModal"

// Import Libre Franklin font weights used in design
import "@fontsource/libre-franklin/400.css"
import "@fontsource/libre-franklin/500.css"
import "@fontsource/libre-franklin/600.css"
import "@fontsource/libre-franklin/700.css"
import "@fontsource/libre-franklin/800.css"

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <ChakraProvider value={system}>
    <LeadFormProvider>
      <GetStartedProvider>
        <OwnerLeadFormProvider>
          {element}
          <LeadFormModal />
          <GetStartedChoiceModal />
        </OwnerLeadFormProvider>
      </GetStartedProvider>
    </LeadFormProvider>
  </ChakraProvider>
)

export const wrapPageElement = ({
  element,
  props,
}: {
  element: React.ReactNode
  props: { location: { pathname: string } }
}) => <Layout pathname={props.location.pathname}>{element}</Layout>

// Meta Pixel + GTM/GA4: the base code in gatsby-ssr already fires the first
// PageView (Meta) and the GA4 config tag fires the first page_view (GA4) on
// load, so skip onRouteUpdate's initial call and only track subsequent
// client-side (SPA) navigations to avoid double-counting the landing page.
let isInitialRoute = true
export const onRouteUpdate = ({
  location,
}: {
  location: { pathname: string; search: string; href: string }
}) => {
  if (isInitialRoute) {
    isInitialRoute = false
    return
  }

  const win = window as unknown as {
    fbq?: (...args: unknown[]) => void
    dataLayer?: Array<Record<string, unknown>>
  }

  if (typeof win.fbq === "function") {
    win.fbq("track", "PageView")
  }

  // GTM: emit a custom event GA4 can turn into a page_view for the new route.
  // No-ops when the container is absent (dataLayer never created). A GA4 Event
  // tag in the GTM UI listens for `spa_route_change` — see SETUP.md Step 8.
  if (Array.isArray(win.dataLayer)) {
    win.dataLayer.push({
      event: "spa_route_change",
      page_path: `${location.pathname}${location.search}`,
      page_location: location.href,
      page_title: typeof document !== "undefined" ? document.title : undefined,
    })
  }
}
